var exports = {
  "d2": "x936d19a0--cdab60--error-block",
  "Cx": "x936d19a0--cdab60--full-size",
  "_S": "x936d19a0--cdab60--sign",
  "DD": "x936d19a0--cdab60--title",
  "x6": "x936d19a0--cdab60--button",
};

module.exports = exports;
